/**
 * Shared class strings for the watercraft auth forms so the login and create-account screens stay in sync.
 */
export const WATERCRAFT_SUBMIT_BUTTON_CLASS =
  'h-11 w-full rounded-lg border-none bg-watercraft-primary text-base font-semibold text-watercraft-text-primary hover:bg-watercraft-primary-light';

export const WATERCRAFT_INPUT_CLASS = 'py-3 text-base';
